{
  "tabs": {
    "chat": "ଚାଟ୍",
    "reminders": "ସ୍ମରଣୀକା",
    "calendar": "କ୍ୟାଲେଣ୍ଡର୍",
    "settings": "ସେଟିଂସ୍"
  },
  "common": {
    "cancel": "ବାତିଲ୍ କରନ୍ତୁ",
    "save": "ସଞ୍ଚୟ କରନ୍ତୁ",
    "confirm": "ନିଶ୍ଚିତ କରନ୍ତୁ",
    "delete": "ମିଟାନ୍ତୁ",
    "back": "ପଛକୁ",
    "close": "ବନ୍ଦ କରନ୍ତୁ",
    "edit": "ସମ୍ପାଦନା",
    "search": "ଖୋଜନ୍ତୁ",
    "all": "ସବୁ",
    "loading": "ଲୋଡ୍ ହେଉଛି...",
    "error": "କିଛି ଭୁଲ ଘଟିଛି",
    "notFound": "ମିଳିଲା ନାହିଁ",
    "tryAgain": "ଦୟାକରି ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ",
    "retry": "ପୁନଃଚେଷ୍ଟା",
    "undo": "ପୁନଃସ୍ଥାପନା",
    "pullToRefresh": "ତାଜା କରିବାକୁ ଟାଣନ୍ତୁ",
    "justNow": "ଏବେ ମାତ୍ର"
  },
  "auth": {
    "welcome": "FishMemory କୁ ସ୍ୱାଗତ",
    "tagline": "ଆପଣଙ୍କର WhatsApp ସ୍ମରଣୀକା ସହାୟକ, ଏବେ ଆପଣଙ୍କର ଜେବାରେ।",
    "subtitle": "ଆପଣଙ୍କର WhatsApp ସ୍ମରଣୀକା ସହାୟକ, ଏବେ ଆପଣଙ୍କର ଜେବାରେ।",
    "phoneLabel": "ଆପଣଙ୍କର WhatsApp ନମ୍ବର",
    "phoneHint": "ଆମେ WhatsApp ମାଧ୍ୟମରେ ଏକ ସତ୍ୟାପନ କୋଡ୍ ପଠାଇବୁ",
    "invalidPhone": "ଦୟାକରି ସଠିକ୍ ଫୋନ୍ ନମ୍ବର ଦିଅନ୍ତୁ",
    "continue": "ଚାଲୁ ରଖନ୍ତୁ",
    "enterPhone": "ଆପଣଙ୍କର WhatsApp ନମ୍ବର ଦିଅନ୍ତୁ",
    "phonePlaceholder": "ଫୋନ୍ ନମ୍ବର",
    "sendCode": "କୋଡ୍ ପଠାନ୍ତୁ",
    "verifyTitle": "ଆପଣଙ୍କର ନମ୍ବର ସତ୍ୟାପନ କରନ୍ତୁ",
    "otpSentTo": "6-ଆଙ୍କର କୋଡ୍ {{phone}} କୁ WhatsApp ମାଧ୍ୟମରେ ପଠାଯାଇଛି",
    "enterFullCode": "ଦୟାକରି ସମସ୍ତ 6 ଆଙ୍କ ଦିଅନ୍ତୁ",
    "invalidOtp": "ଅବୈଧ କୋଡ୍। ଦୟାକରି ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
    "otpFailed": "କୋଡ୍ ପଠାଇବାରେ ବିଫଳ। ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
    "otpResent": "କୋଡ୍ ପୁନଃପଠାଇ ଦିଆଗଲା",
    "resendIn": "{{seconds}} ସେକେଣ୍ଡରେ ପୁନଃପଠାନ୍ତୁ",
    "resendCode": "କୋଡ୍ ପୁନଃପଠାନ୍ତୁ",
    "enterOtp": "ଆପଣଙ୍କର WhatsApp କୁ ପଠାଯାଇଥିବା କୋଡ୍ ଦିଅନ୍ତୁ",
    "verify": "ସତ୍ୟାପନ କରନ୍ତୁ",
    "resend": "କୋଡ୍ ପୁନଃପଠାନ୍ତୁ",
    "wrongNumber": "ଭୁଲ ନମ୍ବର?",
    "backToPhone": "ଫୋନ୍ ପାଖରେ ଫେରନ୍ତୁ",
    "editPhone": "ଫୋନ୍ ନମ୍ବର ସମ୍ପାଦନା କରନ୍ତୁ",
    "error": "ତ୍ରୁଟି",
    "setupTitle": "ଆସନ୍ତୁ ବ୍ୟବସ୍ଥା କରିବା",
    "setupSubtitle": "ଆପଣ ପରେ ସେଟିଂସ୍ ରେ ଏହାକୁ ପରିବର୍ତ୍ତନ କରିପାରିବେ",
    "namePlaceholder": "ଆପଣଙ୍କର ନାମ",
    "letsGo": "ସେଟଅପ୍ ସମାପ୍ତ କରନ୍ତୁ",
    "skipForNow": "ଏବେ ବାତିଲ୍ କରନ୍ତୁ"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "ଏକ ସନ୍ଦେଶ ଟାଇପ୍ କରନ୍ତୁ...",
    "inputPlaceholder": "ଏକ ସନ୍ଦେଶ ଟାଇପ୍ କରନ୍ତୁ...",
    "typing": "FishMemory ଟାଇପ୍ କରୁଛି...",
    "online": "ଅନଲାଇନ୍",
    "connecting": "ଯୋଗାଯୋଗ ହେଉଛି...",
    "reconnecting": "ପୁନଃଯୋଗାଯୋଗ ହେଉଛି...",
    "offline": "ଅଫଲାଇନ୍",
    "empty": "ଆଲୋଚନା ଆରମ୍ଭ କରନ୍ତୁ",
    "emptyHint": "ସ୍ମରଣୀକା ସୃଷ୍ଟି କରନ୍ତୁ, ଆପଣଙ୍କର ସୂଚୀ ଯାଞ୍ଚ କରନ୍ତୁ, କିମ୍ବା ସହାୟତା ମାଗନ୍ତୁ।",
    "emptyAction": "ନମୁନା ସ୍ମରଣୀ ପଠାନ୍ତୁ",
    "actions": "ଚାଟ୍ କାର୍ଯ୍ୟ",
    "keep": "ସନ୍ଦେଶ ରଖନ୍ତୁ",
    "clearTitle": "ଚାଟ୍ ସଫା କରନ୍ତୁ",
    "clearConfirm": "ଏହି ଡିଭାଇସରୁ ସମସ୍ତ ସନ୍ଦେଶ ମିଟାଇବେ? ଏହା ପୁନଃପ୍ରାପ୍ତ ହେବ ନାହିଁ।",
    "clear": "ଚାଟ୍ ସଫା କରନ୍ତୁ",
    "optionSelected": "ଚୟନିତ: {{label}}",
    "sendingSelection": "ପଠାଯାଉଛି...",
    "connectionLost": "ପୁନଃଯୋଗାଯୋଗ ହେଉଛି..."
  },
  "reminders": {
    "title": "ମୋର ସ୍ମରଣୀକା",
    "active": "ସକ୍ରିୟ",
    "today": "ଆଜି",
    "thisWeek": "ଏହି ସପ୍ତାହ",
    "history": "ଇତିହାସ",
    "items": "ଆଇଟମ୍",
    "emptyTitle": "ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ସ୍ମରଣୀ ନାହିଁ",
    "emptySubtitle": "ଚାଟ୍ ରୁ ଏକ ସୃଷ୍ଟି କରନ୍ତୁ ଏବଂ ଏଠାରେ ଦେଖାଯିବ।",
    "emptyAction": "ଚାଟ୍ ଖୋଲନ୍ତୁ",
    "filterActive": "ସକ୍ରିୟ",
    "filterToday": "ଆଜି",
    "filterWeek": "ଏହି ସପ୍ତାହ",
    "filterHistory": "ଇତିହାସ",
    "emptyState": "ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ସ୍ମରଣୀ ନାହିଁ। ଆଲୋଚନା ଆରମ୍ଭ କରନ୍ତୁ!",
    "swipeDone": "ସମାପ୍ତ",
    "swipeSnooze": "ସ୍ନୁଜ୍",
    "swipeDelete": "ମିଟାନ୍ତୁ",
    "search": "ସ୍ମରଣୀକା ଖୋଜନ୍ତୁ...",
    "upcoming": "ଆସନ୍ତା",
    "completed": "ସମାପ୍ତ",
    "overdue": "ବିଳମ୍ବିତ",
    "tomorrow": "କାଲି",
    "synced": "ସିଙ୍କ୍ ହେଲା {{value}}",
    "swipeHint": "ଅଧିକ କାର୍ଯ୍ୟ ପାଇଁ ସ୍ମରଣୀକୁ ସ୍ୱାଇପ୍ କରନ୍ତୁ",
    "noResults": "ଆପଣଙ୍କର ଖୋଜ ସହିତ କୌଣସି ସ୍ମରଣୀ ମେଳାଉନାହିଁ",
    "noResultsHint": "ଭିନ୍ନ କୀୱାର୍ଡ୍ ଚେଷ୍ଟା କରନ୍ତୁ କିମ୍ବା ଖୋଜ ସଫା କରନ୍ତୁ",
    "deleteAllFailed": "ସମସ୍ତ ସ୍ମରଣୀ ମିଟାଇବାରେ ବିଫଳ"
  },
  "calendar": {
    "title": "କ୍ୟାଲେଣ୍ଡର୍",
    "today": "ଆଜି",
    "tomorrow": "କାଲି",
    "completed": "ସମାପ୍ତ",
    "noEvents": "କୌଣସି କାର୍ଯ୍ୟ ସୂଚୀଭୁକ୍ତ ନାହିଁ",
    "noEventsSubtitle": "ସ୍ମରଣୀକା ଏବଂ କ୍ୟାଲେଣ୍ଡର୍ କାର୍ଯ୍ୟ ଦେଖିବା ପାଇଁ ତାରିଖ ଚୟନ କରନ୍ତୁ।",
    "googleEvent": "Google Calendar",
    "legendActive": "ସକ୍ରିୟ",
    "legendRecurring": "ପୁନଃ ପ୍ରକାଶିତ",
    "legendDone": "ସମାପ୍ତ",
    "legendGoogle": "Google",
    "previousMonth": "ଗତ ମାସ",
    "nextMonth": "ପରବର୍ତ୍ତୀ ମାସ",
    "previousYear": "ଗତ ବର୍ଷ",
    "nextYear": "ପରବର୍ତ୍ତୀ ବର୍ଷ",
    "goToToday": "ଆଜିକୁ ଯାଆନ୍ତୁ",
    "all": "ସବୁ",
    "active": "ସକ୍ରିୟ",
    "done": "ସମାପ୍ତ",
    "paused": "ବିରତି"
  },
  "settings": {
    "title": "ସେଟିଂସ୍",
    "profile": "ପ୍ରୋଫାଇଲ୍",
    "name": "ଦର୍ଶାଉଥିବା ନାମ",
    "enterName": "ଆପଣଙ୍କର ନାମ ଦିଅନ୍ତୁ",
    "language": "ଭାଷା",
    "uiLanguage": "ଆପ୍ ଭାଷା",
    "uiLanguageHelp": "ଏହା ଏହି ଡିଭାଇସରେ କେବଳ ଆପ୍ UI, କ୍ୟାଲେଣ୍ଡର୍ ଲେବଲ୍ ଏବଂ ଲେଆଉଟ୍ ଦିଗ ରେ ପରିବର୍ତ୍ତନ କରିଥାଏ।",
    "serverLanguage": "ଚାଟ୍ ଭାଷା",
    "serverLanguageHelp": "ଆପଣଙ୍କର ଖାତା ପାଇଁ ସର୍ଭର୍ ଉତ୍ତର ଏବଂ ସ୍ମରଣୀକା ସନ୍ଦେଶରେ ବ୍ୟବହୃତ ଭାଷା ପରିବର୍ତ୍ତନ କରେ।",
    "timezone": "ସମୟ ମଣ୍ଡଳ",
    "currentTimezone": "ବର୍ତ୍ତମାନ ସମୟ ମଣ୍ଡଳ",
    "timezoneHelp": "ସମସ୍ତ ସ୍ମରଣୀ ସମୟ ଏହି ସମୟ ମଣ୍ଡଳ ଅନୁସାରେ ଦେଖାଯାଏ।",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "ସମୟ ମଣ୍ଡଳ ସଞ୍ଚୟ କରନ୍ତୁ",
    "timezoneSaved": "ସମୟ ମଣ୍ଡଳ ଅଦ୍ୟତିତ",
    "detect": "ସନ୍ଧାନ କରନ୍ତୁ",
    "detectFailed": "ସମୟ ମଣ୍ଡଳ ସନ୍ଧାନ କରିପାରିଲା ନାହିଁ",
    "autoDetect": "GPS ରୁ ସ୍ୱୟଂଚାଳିତ ସନ୍ଧାନ",
    "notifications": "ସୂଚନା",
    "notificationsHelp": "ଫଲୋ-ଅପ୍ ସ୍ମରଣୀକା ସ୍ମରଣୀ ପ୍ରଦାନ ପରେ ପୁନଃ ସୂଚନା ନିୟନ୍ତ୍ରଣ କରେ। ଡିଭାଇସ୍-ସ୍ତରର ସୂଚନା ଅନୁମତି ଆପଣଙ୍କର ଫୋନ୍ ସେଟିଂସ୍ ରେ ମ୍ୟାନେଜ୍ ହୁଏ।",
    "pushEnabled": "ପୁସ୍ ସୂଚନା",
    "autoDoneOnFire": "ଚାଲୁ ହେବା ସମୟରେ ସ୍ୱୟଂଚାଳିତ ସମାପ୍ତ",
    "autoDoneOnFireDesc": "ଅଫ୍ ଥିଲେ, ସ୍ମରଣୀକା ସକ୍ରିୟ ରହିଥାଏ ଯାଯେପର୍ଯ୍ୟନ୍ତ ଆପଣ ସମାପ୍ତ ମାର୍କ୍ କରନ୍ତି।",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "ସଂଯୁକ୍ତ",
    "googleDisconnected": "ଅସଂଯୁକ୍ତ",
    "googleConnectedHelp": "ନୂତନ ସ୍ମରଣୀକୁ ସ୍ୱୟଂଚାଳିତ ଭାବେ ଆପଣଙ୍କର କ୍ୟାଲେଣ୍ଡର୍ ସହ ସିଙ୍କ୍ କରାଯାଇପାରିବ।",
    "googleDisconnectedHelp": "ସ୍ମରଣୀ ଏବଂ କାର୍ଯ୍ୟଗୁଡିକୁ ସମନ୍ୱୟ କରିବା ପାଇଁ Google Calendar ସଂଯୋଗ କରନ୍ତୁ।",
    "googleConnectFailed": "Google Calendar ସଂଯୋଗ କରିବାରେ ବିଫଳ",
    "connected": "ସଂଯୁକ୍ତ",
    "disconnected": "ଅସଂଯୁକ୍ତ",
    "connect": "ସଂଯୋଗ କରନ୍ତୁ",
    "disconnect": "ବିଚ୍ଛିନ୍ନ କରନ୍ତୁ",
    "autoSync": "ନୂତନ ସ୍ମରଣୀ ସ୍ୱୟଂଚାଳିତ ସିଙ୍କ୍",
    "autosync": "ନୂତନ ସ୍ମରଣୀ ସ୍ୱୟଂଚାଳିତ ସିଙ୍କ୍",
    "subscription": "ସଦସ୍ୟତା",
    "trialUsed": "ଟ୍ରାୟଲ୍: {{used}}/{{total}} ବ୍ୟବହୃତ",
    "trialStatus": "ଟ୍ରାୟଲ୍ ଉପଲବ୍ଧ",
    "activeStatus": "ସକ୍ରିୟ ସଦସ୍ୟତା",
    "expiredStatus": "ସଦସ୍ୟତା ସମାପ୍ତ",
    "unsubscribedStatus": "ସଦସ୍ୟତା ନାହିଁ",
    "about": "ବିଷୟରେ",
    "version": "ସଂସ୍କରଣ",
    "logout": "ଲଗ୍ ଆଉଟ୍",
    "logoutTitle": "ଲଗ୍ ଆଉଟ୍",
    "logoutConfirm": "ଆପଣ ନିଶ୍ଚିତ ଭାବେ ଲଗ୍ ଆଉଟ୍ ହେବାକୁ ଚାହାଁଛନ୍ତି?",
    "noName": "ନାମ ସେଟ୍ ହୋଇନାହିଁ",
    "serverConnection": "ସର୍ଭର୍ ସଂଯୋଗ",
    "serverUrl": "ସର୍ଭର୍ URL",
    "serverEdit": "ସମ୍ପାଦନା",
    "saveReconnect": "ସଞ୍ଚୟ କରନ୍ତୁ ଏବଂ ପୁନଃଯୋଗାଯୋଗ କରନ୍ତୁ",
    "resetDefault": "ଡିଫଲ୍ଟ ରିସେଟ୍ କରନ୍ତୁ",
    "invalidServerUrlTitle": "ଅବୈଧ ସର୍ଭର୍ URL",
    "invalidServerUrlMessage": "ଦୟାକରି ସଠିକ୍ http କିମ୍ବା https ସର୍ଭର୍ URL ଦିଅନ୍ତୁ, ଯଥା https://example.com",
    "uiLanguageChangeFailed": "ଆପ୍ ଭାଷା ପରିବର୍ତ୍ତନ କରିବାରେ ବିଫଳ। ଦୟାକରି ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
    "serverLanguageChangeFailed": "ଚାଟ୍ ଭାଷା ପରିବର୍ତ୍ତନ କରିବାରେ ବିଫଳ। ଦୟାକରି ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
    "timezoneChangeFailed": "ସମୟ ମଣ୍ଡଳ ପରିବର୍ତ୍ତନ କରିବାରେ ବିଫଳ। ଦୟାକରି ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
    "autoSyncChangeFailed": "ସ୍ୱୟଂଚାଳିତ ସିଙ୍କ୍ ଅଦ୍ୟତନ କରିବାରେ ବିଫଳ। ଦୟାକରି ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
    "nameChangeFailed": "ଦର୍ଶାଉଥିବା ନାମ ଅଦ୍ୟତନ କରିବାରେ ବିଫଳ। ଦୟାକରି ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ସ୍ମରଣୀ ବିବରଣୀ",
    "editTime": "ସମୟ ସମ୍ପାଦନା",
    "rename": "ନାମ ପରିବର୍ତ୍ତନ",
    "snooze": "ସ୍ନୁଜ୍",
    "snooze15": "15 ମିନିଟ୍ ସ୍ନୁଜ୍",
    "pause": "ବିରତି",
    "pauseReminder": "ସ୍ମରଣୀ ବିରତି କରନ୍ତୁ",
    "resume": "ପୁନଃ ଆରମ୍ଭ",
    "resumeReminder": "ସ୍ମରଣୀ ପୁନଃ ଆରମ୍ଭ କରନ୍ତୁ",
    "skip": "ପରବର୍ତ୍ତୀକୁ ଛାଡ଼ନ୍ତୁ",
    "skipOccurrence": "ଏହି ଘଟଣା ଛାଡ଼ନ୍ତୁ",
    "syncGoogle": "Google ସହ ସିଙ୍କ୍ କରନ୍ତୁ",
    "delete": "ମିଟାନ୍ତୁ",
    "deleteTitle": "ସ୍ମରଣୀ ମିଟାନ୍ତୁ",
    "deleteConfirm": "ଏହି ସ୍ମରଣୀ ସ୍ଥାୟୀ ଭାବେ ମିଟିଯିବ।",
    "deleteRecurringTitle": "ପୁନଃ ପ୍ରକାଶିତ ସ୍ମରଣୀ ମିଟାନ୍ତୁ",
    "deleteRecurringMessage": "ଆପଣ ଏହି ଘଟଣା ଛାଡ଼ିବେ କିମ୍ବା ସମସ୍ତ ଶ୍ରେଣୀକୁ ମିଟାଇବେ?",
    "deleteThisOccurrence": "ଏହି ଘଟଣା ଛାଡ଼ନ୍ତୁ",
    "deleteEntireSeries": "ସମସ୍ତ ଶ୍ରେଣୀ ମିଟାନ୍ତୁ",
    "done": "ସମାପ୍ତ",
    "markDone": "ସମାପ୍ତ ମାର୍କ୍ କରନ୍ତୁ",
    "undo": "ପୁନଃସ୍ଥାପନା",
    "undoPrompt": "ପୁନଃ ସକ୍ରିୟ କରିବାକୁ ଚାହାଁଛନ୍ତି? ଏବେ ପୁନଃସ୍ଥାପନା କରନ୍ତୁ।",
    "recurring": "ପୁନଃ ପ୍ରକାଶିତ",
    "nextRun": "ପରବର୍ତ୍ତୀ ଚାଲାଣ",
    "oneTime": "ଏକଥର",
    "pending": "ପେଣ୍ଡିଂ",
    "sent": "ପଠାଯାଇଛି",
    "paused": "ବିରତି",
    "active": "ସକ୍ରିୟ",
    "snoozed": "ସ୍ନୁଜ୍ ହୋଇଛି",
    "localTime": "ଆପଣଙ୍କର ସ୍ଥାନୀୟ ସମୟରେ ଦେଖାଯାଏ",
    "recurrence": "ପୁନଃ ପ୍ରକାଶ",
    "created": "ତିଆରି",
    "tags": "ଟ୍ୟାଗ୍",
    "fireCount": "ଚାଲୁ ହେବା ସଂଖ୍ୟା",
    "actions": "କାର୍ଯ୍ୟ",
    "none": "କିଛି ନାହିଁ",
    "snoozeFailed": "ସ୍ମରଣୀ ସ୍ନୁଜ୍ କରିବାରେ ବିଫଳ",
    "pauseFailed": "ସ୍ମରଣୀ ବିରତି କରିବାରେ ବିଫଳ",
    "resumeFailed": "ସ୍ମରଣୀ ପୁନଃ ଆରମ୍ଭ କରିବାରେ ବିଫଳ",
    "skipFailed": "ସ୍ମରଣୀ ଛାଡ଼ିବାରେ ବିଫଳ",
    "doneFailed": "ସ୍ମରଣୀ ସମାପ୍ତ ମାର୍କ୍ କରିବାରେ ବିଫଳ",
    "undoFailed": "ସ୍ମରଣୀ ସ୍ଥିତି ପୁନଃସ୍ଥାପନା କରିବାରେ ବିଫଳ",
    "deleteFailed": "ସ୍ମରଣୀ ମିଟାଇବାରେ ବିଫଳ",
    "rescheduleTitle": "ପୁନଃ ସମୟ ନିର୍ଦ୍ଧାରଣ କରିବେ?",
    "rescheduleMsg": "ଏହି ସ୍ମରଣୀ ବିଳମ୍ବିତ। ଆପଣ ଏହାକୁ ପୁନଃ ସମୟ ନିର୍ଦ୍ଧାରଣ କରିବେ କି?",
    "reschedule15": "15 ମିନିଟ୍ ପରେ",
    "reschedule60": "1 ଘଣ୍ଟା ପରେ",
    "keepOverdue": "ଯଥା ଅଛି ରଖନ୍ତୁ"
  },
  "onboarding": {
    "slide1Title": "FishMemory କୁ ସ୍ୱାଗତ",
    "slide1Sub": "ଆପଣଙ୍କର ବ୍ୟକ୍ତିଗତ ସ୍ମରଣୀ ସହାୟକ — WhatsApp ଦ୍ୱାରା ସଚାଳିତ ଏବଂ ଆପଣଙ୍କର ଜେବା ପାଇଁ ତିଆରି।",
    "slide2Title": "ସହଜ ଭାବେ ଚାଟ୍ କରନ୍ତୁ",
    "slide2Sub": "ଆପଣ ଭାବୁଥିବା ପ୍ରକାର ସ୍ମରଣୀ ଟାଇପ୍ କରନ୍ତୁ: \"ମୋତେ କାଲି 3pm ରେ ମା'କୁ ଫୋନ୍ କରିବାକୁ ସ୍ମରଣ କରା\" — ଆମେ ଅନ୍ୟ ସବୁ ଦେଖିବୁ।",
    "slide3Title": "କେବେ ମିସ୍ ହେବେ ନାହିଁ",
    "slide3Sub": "ସମୟୋପଯୁକ୍ତ ସୂଚନା ପାଆନ୍ତୁ, ଟ୍ୟାଗ୍ ସହିତ ବ୍ୟବସ୍ଥା କରନ୍ତୁ, ଏବଂ ସମସ୍ତ ଜରୁରୀ କଥା ଉପରେ ନିୟନ୍ତ୍ରଣ ରଖନ୍ତୁ।",
    "getStarted": "ଆରମ୍ଭ କରନ୍ତୁ",
    "next": "ପରବର୍ତ୍ତୀ",
    "firstReminderTitle": "ଆପଣଙ୍କର ପ୍ରଥମ ସ୍ମରଣୀ ସୃଷ୍ଟି କରନ୍ତୁ!",
    "firstReminderHint": "ଏହା ପରି କିଛି ଟାଇପ୍ କରିଦେଖନ୍ତୁ:",
    "firstReminderExample": "ମୋତେ କାଲି ସକାଳ 9ଟାରେ ପାଣି ପିଇବାକୁ ସ୍ମରଣ କରା",
    "gotIt": "ବୁଝିଗଲି!",
    "notifRationaleTitle": "ସମୟରେ ରୁହନ୍ତୁ",
    "notifRationaleBody": "FishMemory କୁ ସମୟରେ ସ୍ମରଣ କରାଇବା ପାଇଁ ସୂଚନା ଆବଶ୍ୟକ। ଆପଣ କେବଳ ଆପଣଙ୍କର ସୃଷ୍ଟି କରାଯାଇଥିବା ସ୍ମରଣୀ ପାଇଁ ସୂଚନା ପାଇବେ।",
    "notifRationaleAllow": "ସୂଚନା ସକ୍ରିୟ କରନ୍ତୁ",
    "notifRationaleLater": "ପରେ ହେବ",
    "swipeHint": "ଦ୍ରୁତ କାର୍ଯ୍ୟ ପାଇଁ ଡାହାଣକୁ ସ୍ୱାଇପ୍ କରନ୍ତୁ →",
    "calendarDragHint": "ବିସ୍ତାର କରିବାକୁ ଟାଣନ୍ତୁ ↕"
  }
}
